/** @jsxImportSource theme-ui */

import React from 'react';
import { StackProps } from '../utils/types';
import { ErrorProps } from '../utils/types/error';

export interface LabelProps extends StackProps, ErrorProps, Omit<React.ComponentPropsWithRef<'label'>, 'css'> {
    header?: string;
    isRequired?: boolean;
}

export const Label = ({ header, isError, isRequired, children, stack, ...otherProps }: LabelProps): JSX.Element => {
    const headerVariant = React.useMemo(() => {
        const ret = ['default'];

        if (isError) {
            ret[0] = 'error';
        }
        if (isRequired) {
            ret[1] = 'required';
        }
        return ret.join('-');
    }, [isRequired, isError]);

    const labelVariant = React.useMemo(() => {
        let ret = 'default';

        if (isError) {
            ret = 'error';
        }
        return ret;
    }, [isError]);

    return (
        <label
            sx={{
                marginBottom: stack,
                variant: `forms.label-${labelVariant}`,
            }}
            {...otherProps}
        >
            {header && (
                <span
                    sx={{
                        variant: `forms.label-header-${headerVariant}`,
                    }}
                >
                    {header}
                </span>
            )}
            {children}
        </label>
    );
};
